import { useContext } from "react";
import { useForm } from "react-hook-form";
import CustomerApi from "../../../api/customer";
import AuthContext from "../../../components/auth-context";
import useAppNavigate from "../../../components/router/use-app-navigate";
import Form from "../../../components/inputs/form";
import Password from "../../../components/inputs/password";
import Submit from "../../../components/inputs/submit";
import { useState } from "react";

interface RequestForm {
  currentPassword: string;
  password: string;
  rePassword: string;
}

export interface IChangePasswordProps {}

export default function ChangePassword(props: IChangePasswordProps) {
  const context = useContext(AuthContext);
  const { register, handleSubmit } = useForm<RequestForm>();
  const navigate = useAppNavigate();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const onSubmit: (data: any) => Promise<string> = ({
    currentPassword,
    password,
    rePassword,
  }) => {
    if (password !== rePassword)
      return new Promise((resolve) =>
        resolve("کلمه عبور و تکرار آن یکسان نیستند"),
      );
    setIsSubmit(true);
    const customerApi = new CustomerApi(context);
    return customerApi
      .put({ currentPassword, password })
      .then(({ errorMessage }) => {
        setIsSubmit(false);
        if (!errorMessage) {
          navigate("../");
        } else setErrorMessage(errorMessage);
        return errorMessage;
      });
  };

  return (
    <Form submit={onSubmit} handleSubmit={handleSubmit}>
      {errorMessage && (
        <div className="text-red-500 text-right p-3 mb-4">{errorMessage}</div>
      )}
      <Password
        {...register("currentPassword", { required: true })}
        label="کلمه عبور جاری"
      />
      <Password
        {...register("password", { required: true })}
        label="رمز عبور جدید"
      />
      <Password
        {...register("rePassword", { required: true })}
        label="تکرار رمز عبور جدید"
      />
      <Submit loading={isSubmit} />
    </Form>
  );
}
